<div class="main-menu">
    <app-user-details
        [userName]="userData?.user?.username"
        [hasAdminRights]="hasAdminRights"
        [canAccessSuperadminSection]="canAccessSuperadminSection"
        (signoutEvent)="onSignout()"
        (toggleProfileEvent)="onToggleProfile()"
    ></app-user-details>

    <div class="nav_channels_list_wrapper styled-scrollbar styled-scrollbar-transparent">
        <div class="sb_element">
            <ul class="nav_list" #navlist>
                @if (adminOrSuperAdmin) {
                    <li>
                        <a routerLink="/app/search" routerLinkActive="active"
                            ><mat-icon class="icon_search size-auto"><i class="far fa-search"></i></mat-icon>Search</a
                        >
                    </li>
                    <li class="saved-searches-link">
                        <a routerLink="/app/searches" routerLinkActive="active"
                            ><mat-icon><i class="fal fa-radar"></i></mat-icon>Monitored searches</a
                        >
                    </li>
                    <li class="menu-sections-divider"></li>
                    <div>
                        <ul class="nav_name_list taxonomy">
                            <li>
                                <a id="discoverNavLink" routerLink="/app/channels" routerLinkActive="active"
                                    ><mat-icon><i class="fal fa-list-alt"></i></mat-icon> Channels</a
                                >
                            </li>
                            <li>
                                <a routerLink="/app/tags" routerLinkActive="active"
                                    ><mat-icon><i class="fal fa-tag"></i></mat-icon> Tags</a
                                >
                            </li>
                            <li>
                                <a routerLink="/app/post/add" routerLinkActive="active" id="addArticleNavLink"
                                    ><mat-icon><i class="fal fa-file-plus"></i></mat-icon> Add post</a
                                >
                            </li>
                        </ul>
                    </div>
                }
            </ul>
            <app-channels-list
                [userData]="userData"
                [hasAdminRights]="hasAdminRights"
                [canAccessSuperadminSection]="canAccessSuperadminSection"
            ></app-channels-list>
        </div>
    </div>

    @if (trialDays$ | async; as trialDays) {
        <app-trial-expire [trialDays]="trialDays"></app-trial-expire>
    }
</div>
